var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('div',[_vm._v("Loading...")]),_c('portal',{attrs:{"to":"app-bar-title"}},[_vm._v("Kirkebesøg")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }